import React from 'react';
import HoursManagementContextPropsType from './HoursManagementContextPropTypes';
import config from './config';

export default React.createContext<HoursManagementContextPropsType>(config);
